import { faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import Style from './Comment.module.css'

const Comment = (props) => {
    let replyChecker=null
    if(props.commentDetail.replies.message===undefined){
        replyChecker=null
    }
    else{
        replyChecker=<div className={Style.answer}>
                <h2 className={Style.pasokh}>پاسخ :</h2>
                <h3 className={Style.answerText}>{props.commentDetail.replies.message}</h3>
        </div>
    }
    return (
        <section className={Style.comment}>
            <div className={Style.name}><h4>{props.commentDetail.name}</h4><div className={Style.rateHolder}><FontAwesomeIcon icon={faStar}/>{props.commentDetail.score}</div></div>
            <h3 className={Style.date}>{props.commentDetail.date}</h3>
            <h2 className={Style.commentText}>{props.commentDetail.message}</h2>
            {
                replyChecker
            }
            <ul className={Style.FoodOrderHolder}>
                {
                    props.commentDetail.products.map(item=>{
                        return(

                            <li key={item.id}><p>{item.name}</p></li>
                        )
                    })
                }
                
            </ul>
        </section>
    )
}

export default Comment
